export const ReceiptLanguages = {
    esc: 1,
    starGraphic: 2,
    starLine: 3,
    starPrint: 4,
} as const;

export type ReceiptLanguage = typeof ReceiptLanguages[keyof typeof ReceiptLanguages];
